// extracted by mini-css-extract-plugin
export default {"scroll-top":"scroll-top_scroll-top__Wg-2X","btn":"scroll-top_btn__nII0p"};